<template lang="pug">
  section
    b-container
      b-nav
        b-nav-item(:to="{name: 'AccountProfile'}") Profile
    b-container.pt-3
      router-view
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/Analytics.vue